module.exports = __webpack_public_path__ + "img/addCard.450d916d.svg";